import { UpdateAttendanceSettingMutationVariables } from 'generated/resources/graphql'

import { useForm } from 'modules/core/hooks/useForm'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import { EventTypes, dispatch } from 'modules/core/lib/pubSub'
import app from 'modules/core/store/models/app'

import { useUpdateTimeTrackingSetting } from 'modules/attendance/components/SettingItemPage/TimeTracking/hooks/useUpdateTimeTrackingSetting'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

const TimeTrackingSettingForm = (setting: AttendanceSetting) => {
  const attendanceSetting = setting.toJS()
  const defaultValues: UpdateAttendanceSettingMutationVariables = {
    id: attendanceSetting.id,
    autofillTimesheet: attendanceSetting.autofill_timesheet,
    desktopClockin: attendanceSetting.desktop_clockin,
    editTimesheetAuthorization: attendanceSetting.edit_timesheet_authorization,
    effectiveAt: attendanceSetting.effective_at,
    employeeAccessSearchField: attendanceSetting.employee_access_search_field,
    enableBreaks: attendanceSetting.enable_breaks,
    enableClockInLocation: attendanceSetting.enable_clock_in_location,
    extraHoursBaseline: attendanceSetting.extra_hours_baseline,
    extraHoursTransferFrequency: attendanceSetting.extraHoursTransferFrequency,
    faceRecognition: attendanceSetting.face_recognition,
    forgotClockOut: attendanceSetting.forgot_clock_out,
    forgotClockOutToleranceMinutes: attendanceSetting.forgot_clock_out_tolerance_minutes,
    geofencing: attendanceSetting.geofencing,
    geolocation: attendanceSetting.geolocation,
    geolocationBlock: attendanceSetting.geolocation_block,
    idClockSharedDevice: attendanceSetting.id_clock_shared_device,
    mobileClockin: attendanceSetting.mobile_clockin,
    overtimeAuthorization: attendanceSetting.overtime_authorization,
    qrCodeClockin: attendanceSetting.qr_code_clockin,
  }

  const { updateSetting } = useUpdateTimeTrackingSetting()

  const form = useForm({
    defaultValues,
    onSubmit: async (data, { setErrors }) => {
      const result = await updateSetting(data)

      const handled = handleResult(result, (errors) => {
        setErrors(errors)

        app.setFlash({
          type: 'wrong',
          message: errors?.effectiveAt || i18n.t('errors.generic_error'),
        })
      })

      if (handled.success && handled.data.employeesSetting) {
        dispatch({
          type: EventTypes.TIMETRACKING_POLICY_UPDATED,
        })
      }

      return handled
    },
  })

  return form
}

export default TimeTrackingSettingForm
